/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Org_Remove_MemberInputs */

const th_org_remove_member = /** @type {(inputs: Org_Remove_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`นำออก`)
};

const en_org_remove_member = /** @type {(inputs: Org_Remove_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove`)
};

const ja_org_remove_member = /** @type {(inputs: Org_Remove_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`削除`)
};

const zh_org_remove_member = /** @type {(inputs: Org_Remove_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移除`)
};

const es_org_remove_member = /** @type {(inputs: Org_Remove_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quitar`)
};

const pt_org_remove_member = /** @type {(inputs: Org_Remove_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover`)
};

const id_org_remove_member = /** @type {(inputs: Org_Remove_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keluarkan`)
};

const fr_org_remove_member = /** @type {(inputs: Org_Remove_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retirer`)
};

const tl_org_remove_member = /** @type {(inputs: Org_Remove_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alisin`)
};

const vi_org_remove_member = /** @type {(inputs: Org_Remove_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loại`)
};

const ko_org_remove_member = /** @type {(inputs: Org_Remove_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`제외`)
};

const de_org_remove_member = /** @type {(inputs: Org_Remove_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entfernen`)
};

const ru_org_remove_member = /** @type {(inputs: Org_Remove_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Убрать`)
};

const tr_org_remove_member = /** @type {(inputs: Org_Remove_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çıkar`)
};

const it_org_remove_member = /** @type {(inputs: Org_Remove_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimuovi`)
};

const pl_org_remove_member = /** @type {(inputs: Org_Remove_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usuń`)
};

const uk_org_remove_member = /** @type {(inputs: Org_Remove_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Прибрати`)
};

const hi_org_remove_member = /** @type {(inputs: Org_Remove_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हटाएँ`)
};

const ar_org_remove_member = /** @type {(inputs: Org_Remove_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إزالة`)
};

const ms_org_remove_member = /** @type {(inputs: Org_Remove_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keluarkan`)
};

const bn_org_remove_member = /** @type {(inputs: Org_Remove_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সরান`)
};

const zh_tw2_org_remove_member = /** @type {(inputs: Org_Remove_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移除`)
};

const zh_hk2_org_remove_member = /** @type {(inputs: Org_Remove_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移除`)
};

const ur_org_remove_member = /** @type {(inputs: Org_Remove_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ہٹائیں`)
};

const fa_org_remove_member = /** @type {(inputs: Org_Remove_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حذف`)
};

const sw_org_remove_member = /** @type {(inputs: Org_Remove_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ondoa`)
};

const nl_org_remove_member = /** @type {(inputs: Org_Remove_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwijderen`)
};

/**
* | output |
* | --- |
* | "Remove" |
*
* @param {Org_Remove_MemberInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const org_remove_member = /** @type {((inputs?: Org_Remove_MemberInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Org_Remove_MemberInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_org_remove_member(inputs)
	if (locale === "ja") return ja_org_remove_member(inputs)
	if (locale === "zh") return zh_org_remove_member(inputs)
	if (locale === "es") return es_org_remove_member(inputs)
	if (locale === "pt") return pt_org_remove_member(inputs)
	if (locale === "id") return id_org_remove_member(inputs)
	if (locale === "fr") return fr_org_remove_member(inputs)
	if (locale === "tl") return tl_org_remove_member(inputs)
	if (locale === "vi") return vi_org_remove_member(inputs)
	if (locale === "ko") return ko_org_remove_member(inputs)
	if (locale === "de") return de_org_remove_member(inputs)
	if (locale === "ru") return ru_org_remove_member(inputs)
	if (locale === "tr") return tr_org_remove_member(inputs)
	if (locale === "it") return it_org_remove_member(inputs)
	if (locale === "pl") return pl_org_remove_member(inputs)
	if (locale === "uk") return uk_org_remove_member(inputs)
	if (locale === "hi") return hi_org_remove_member(inputs)
	if (locale === "ar") return ar_org_remove_member(inputs)
	if (locale === "ms") return ms_org_remove_member(inputs)
	if (locale === "bn") return bn_org_remove_member(inputs)
	if (locale === "zh-TW") return zh_tw2_org_remove_member(inputs)
	if (locale === "zh-HK") return zh_hk2_org_remove_member(inputs)
	if (locale === "ur") return ur_org_remove_member(inputs)
	if (locale === "fa") return fa_org_remove_member(inputs)
	if (locale === "sw") return sw_org_remove_member(inputs)
	if (locale === "nl") return nl_org_remove_member(inputs)
	return en_org_remove_member(inputs)
});